// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quarterBorder {\n  padding-top: 10px;\n  border: 1px solid;\n  border-color: #bbb;\n}", ""]);
// Exports
module.exports = exports;
